import ProductPreviewAdvancedView from './ProductPreviewAdvancedView'

export default ProductPreviewAdvancedView
